import { useWhitelabel } from "@/contexts/whitelabel"

export const FeaturesMandala = () => {
  const { configuration } = useWhitelabel()
  const logoSrc =
    configuration?.merchant?.logo || "/pay2b_logo.svg"
  const features = [
    {
      label: "Pedidos",
      icon: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
    },
    {
      label: "Assinaturas",
      icon: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15",
    },
    {
      label: "Vendas",
      icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
    },
    {
      label: "Webhooks",
      icon: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1",
    },
    {
      label: "Notificações",
      icon: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
    },
    {
      label: "Segurança",
      icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    },
  ]
  const radius = 90
  const center = 130
  return (
    <svg
      width="420"
      height="480"
      viewBox="0 0 280 320"
      className="w-full max-w-[420px]"
    >
      {/* Círculo externo pontilhado */}
      <circle
        cx={center}
        cy={center}
        r={radius + 25}
        fill="none"
        stroke="rgba(255,255,255,0.1)"
        strokeWidth="1"
        strokeDasharray="4 4"
      />
      {/* Círculo do raio */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="1.5"
      />
      {/* Linhas conectando ao centro */}
      {features.map((_, index) => {
        const angle = (index * 360) / features.length - 90
        const radian = (angle * Math.PI) / 180
        const x = center + radius * Math.cos(radian)
        const y = center + radius * Math.sin(radian)
        return (
          <line
            key={`line-${index}`}
            x1={center}
            y1={center}
            x2={x}
            y2={y}
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="1"
          />
        )
      })}
      {/* Centro - Logo Pay2B */}
      <circle
        cx={center}
        cy={center}
        r="32"
        fill="white"
        className="cursor-pointer"
      />
      <image
        href={logoSrc}
        x={center - 25}
        y={center - 12}
        width="50"
        height="24"
        preserveAspectRatio="xMidYMid meet"
      />
      {/* Feature nodes */}
      {features.map((feature, index) => {
        const angle = (index * 360) / features.length - 90
        const radian = (angle * Math.PI) / 180
        const x = center + radius * Math.cos(radian)
        const y = center + radius * Math.sin(radian)
        return (
          <g key={feature.label} className="cursor-pointer">
            {/* Background do node */}
            <circle
              cx={x}
              cy={y}
              r="22"
              fill="rgba(255,255,255,0.1)"
              stroke="rgba(255,255,255,0.2)"
              strokeWidth="1"
            />
            {/* Ícone */}
            <path
              d={feature.icon}
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              transform={`translate(${x - 12}, ${y - 12}) scale(1)`}
            />
            {/* Label */}
            <text
              x={x}
              y={y + 35}
              textAnchor="middle"
              fill="rgba(255,255,255,0.9)"
              fontSize="10"
              fontFamily="Poppins, sans-serif"
            >
              {feature.label}
            </text>
          </g>
        )
      })}
    </svg>
  )
}
